import { type JSX } from 'react';

import { useMatches, useRouterState } from '@tanstack/react-router';

import { useHomeRoute } from '@/hooks/useHomeRoute';
import { useIsMobile } from '@/hooks/useIsMobile';

import { HomeTopBar } from '../HomeTopBar/HomeTopBar';
import { InnerPageTopBar } from '../InnerPageTopBar/InnerPageTopBar';
import { TopbarFactory } from './factories/global-navigation-factory';

type GlobalNavigationProps = {
  onToggle: () => void;
  isMenuOpen?: boolean;
};

export function GlobalNavigation({ onToggle, isMenuOpen = true }: GlobalNavigationProps): JSX.Element {
  const matches = useMatches();
  const { location } = useRouterState();
  const lastMatch = matches.length > 0 ? matches[matches.length - 1] : undefined;
  const { title = '', isBack = true } = lastMatch?.staticData ?? {};
  const isMobile = useIsMobile();
  const homeRoute = useHomeRoute();

  const isHome = location.pathname === homeRoute;

  return (
    <>
      <TopbarFactory>
        {isMobile && !isHome ? (
          <InnerPageTopBar
            title={title}
            isBack={isBack}
            onToggle={onToggle}
            isMenuOpen={isMenuOpen}
          />
        ) : (
          <HomeTopBar
            onToggle={onToggle}
            isMenuOpen={isMenuOpen}
          />
        )}
      </TopbarFactory>
    </>
  );
}
